var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticClass:"d-flex flex-row justify-space-between align-center py-1"},[_c('label',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"val"},[_vm._v(_vm._s(_vm.value))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }